var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "breadcrumb" }, [_c("navbar")], 1),
    _c("div", { staticClass: "Box" }, [
      _c("div", { staticClass: "table_tab" }, [
        _c(
          "div",
          { staticClass: "inquiry" },
          [
            _vm._m(0),
            _c(
              "el-form",
              {
                ref: "queryForm",
                staticClass: "search-form",
                attrs: { inline: true, model: _vm.search, size: "small" },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "客户信息" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入客户信息" },
                      model: {
                        value: _vm.form.customerInfo,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "customerInfo", $$v)
                        },
                        expression: "form.customerInfo",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "订单号" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入订单号" },
                      model: {
                        value: _vm.form.orderNo,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "orderNo", $$v)
                        },
                        expression: "form.orderNo",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "订单日期" } },
                  [
                    _c(
                      "el-date-picker",
                      {
                        attrs: {
                          type: "daterange",
                          "unlink-panels": "",
                          clearable: "",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          format: "yyyy-MM-dd",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          "default-time": ["00:00:00", "23:59:59"],
                        },
                        on: { change: _vm.onChangeTime },
                        model: {
                          value: _vm.allotDate,
                          callback: function ($$v) {
                            _vm.allotDate = $$v
                          },
                          expression: "allotDate",
                        },
                      },
                      [_vm._v(" > ")]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "来源平台" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "请选择来源平台",
                          filterable: "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.platformId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "platformId", $$v)
                          },
                          expression: "form.platformId",
                        },
                      },
                      _vm._l(_vm.platformList, function (item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: { label: item.name, value: item.id },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { plain: "", type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.searchEvent()
                          },
                        },
                      },
                      [_vm._v("搜索")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { plain: "", type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.fetchData("reset")
                          },
                        },
                      },
                      [_vm._v("重置")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c("div", { staticClass: "inquiryTab" }, [
          _vm._m(1),
          _c(
            "div",
            { staticClass: "table" },
            [
              _c("matrix-table", {
                attrs: {
                  dataList: _vm.manage.page.list,
                  config: _vm.manage.config,
                  loading: _vm.manage.loading,
                },
              }),
              _c("div", { staticClass: "page" }, [
                _c(
                  "div",
                  { staticClass: "block" },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": _vm.manage.page.pageNo,
                        "page-size": _vm.manage.page.pageSize,
                        "page-sizes": [3, 5, 10, 20, 50],
                        layout: "total,sizes, prev, pager, next",
                        total: _vm.manage.page.totalNum,
                      },
                      on: {
                        "size-change": _vm.onSizeChange,
                        "current-change": _vm.onCurrentChange,
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "headerbox" }, [
      _c("div", { staticClass: "header" }, [_vm._v(" 数据筛选 ")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "inquiryTab_header" }, [
      _c("div", { staticClass: "tabTitle" }, [_vm._v("积分流水")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }